import React from 'react';
import { friendlyError } from '@/lib/errorMsg';

// Après une mise à jour, un écran pas encore chargé n'existe plus sous son ancien nom : on recharge la page
// une fois, sans afficher d'erreur (16/10/2026). Garde-fou : pas plus d'un rechargement par minute.
const estMiseAJour = (e) => /ChunkLoadError|Loading (CSS )?chunk|dynamically imported module|Importing a module script failed/i.test(`${e?.name} ${e?.message}`);
const rechargerUneFois = () => {
  try {
    const t = Number(sessionStorage.getItem('dmo-rechargement') || 0);
    if (Date.now() - t < 60000) return false;
    sessionStorage.setItem('dmo-rechargement', String(Date.now()));
  } catch { /* sans stockage : on recharge quand même */ }
  window.location.reload();
  return true;
};

export class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }

  static getDerivedStateFromError(error) {
    return { error, miseAJour: estMiseAJour(error) && rechargerUneFois() };
  }

  componentDidCatch(error, info) {
    // eslint-disable-next-line no-console
    console.error('[ErrorBoundary]', error, info);
  }

  reset = () => this.setState({ error: null });

  render() {
    if (this.state.miseAJour) {
      return <div className="min-h-screen bg-[#F9FAFB] flex items-center justify-center p-4 text-sm text-slate-600">Mise à jour de l’application…</div>;
    }
    if (this.state.error) {
      const msg = friendlyError(this.state.error);
      return (
        <div className="min-h-screen bg-[#F9FAFB] flex items-center justify-center p-4">
          <div className="bg-white rounded-lg border border-red-200 shadow-sm p-6 max-w-md w-full">
            <h2 className="text-lg font-bold text-red-700 mb-2">
              Une erreur est survenue
            </h2>
            <p className="text-sm text-slate-700 mb-4 whitespace-pre-wrap break-words"
              data-testid="error-boundary-msg">
              {msg}
            </p>
            <div className="flex gap-2">
              <button onClick={this.reset}
                className="px-4 py-2 bg-[#1F4E79] text-white rounded-md text-sm hover:bg-[#1a3e5f]"
                data-testid="error-boundary-retry">
                Réessayer
              </button>
              <button onClick={() => window.location.reload()}
                className="px-4 py-2 border border-slate-300 text-slate-700 rounded-md text-sm hover:bg-slate-50"
                data-testid="error-boundary-reload">
                Recharger la page
              </button>
            </div>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}

export default ErrorBoundary;
